var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header",style:(_vm.$route.name === 'index' ? 'box-shadow:none' : '')},[_c('div',{staticClass:"header-content"},[_c('router-link',{attrs:{"to":{name: 'index'}}},[_vm._v("首页")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'test'}}},[_vm._v("组件")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc0adea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./examples/components/header.vue
// module id = null
// module chunks = 